import {
  PracticeButtonState,
  PracticeSessionQuestionStatus
} from "services/api/practice/practiceService.types";

const MAX_ATTEMPTS = 3;

export const getButtonState = (
  attemptCount: number,
  lastAttemptCorrect: boolean | null,
  isLastQuestion: boolean,
  isMcqOpen: boolean
): PracticeButtonState => {
  if (attemptCount === 0) return "TakePhoto";

  if (lastAttemptCorrect || attemptCount >= MAX_ATTEMPTS) {
    return isLastQuestion ? "Done" : "NextQuestion";
  }

  if (attemptCount === 1) return "TryAgain";

  if (isMcqOpen) return "AnswerMcq";

  return "AnswerWithMcq";
};

export const getQuestionStatus = (
  attempts: { is_correct: boolean }[]
): PracticeSessionQuestionStatus => {
  if (attempts.length === 0) return PracticeSessionQuestionStatus.InProgress;
  if (attempts[attempts.length - 1].is_correct)
    return PracticeSessionQuestionStatus.Correct;
  if (attempts.length >= MAX_ATTEMPTS)
    return PracticeSessionQuestionStatus.Incorrect;
  return PracticeSessionQuestionStatus.InProgress;
};
